document.addEventListener('click', function (event) {
  const toggle = event.target.closest ? event.target.closest('.jb-explore-view-more-toggle') : null;

  if (!toggle) {
    return;
  }

  event.preventDefault();

  const targetSelector = toggle.getAttribute('href');
  const target = targetSelector ? document.querySelector(targetSelector) : null;

  if (!target) {
    return;
  }

  const isHidden = target.classList.toggle('d-none');
  toggle.classList.toggle('collapsed', isHidden);
  toggle.setAttribute('aria-expanded', isHidden ? 'false' : 'true');
});
